import { Grid, TextField, Button, CssBaseline, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { Formik } from "formik";
import * as Yup from "yup";
import CalebAndBrownLogo from "src/icons/cnbDesktop";
import { LoginStyles } from "../auth/styles/Login.styles";
import { useIsMobile } from "src/utils/hooks/useIsMobile";
import CnbLogoMobile from "src/icons/CnbLogoMobile";
import api from "src/store/features/api";
import { useState } from "react";

export default function MagicLinkForm() {
  const classes = LoginStyles();
  const isMobile = useIsMobile();

  const [submitted, setSubmitted] = useState(false);
  const [sendMagicLink] = api.useMagicLinkMutation();

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email format").required("Please enter your email"),
  });

  return (
    <div className={classes.container}>
      <CssBaseline />
      <Grid container className={classes.logoBox}>
        {isMobile ? <CnbLogoMobile height={"200px"} /> : <CalebAndBrownLogo />}
      </Grid>

      <Grid item xs={12}>
        <Typography>
          It appears that your verification email or magic link may be expired. Please request a new
          email below to verify or access your account.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Formik
          initialValues={{
            email: "",
            submit: null,
          }}
          onSubmit={async (values): Promise<void> => {
            await sendMagicLink({
              magicLinkDto: { email: values.email, redirectUrl: window.location.origin },
            });
            setSubmitted(true);
          }}
          validationSchema={validationSchema}>
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
          }): JSX.Element => (
            <form noValidate onSubmit={handleSubmit} className={classes.formStyles}>
              <TextField
                InputProps={{
                  disableUnderline: true,
                  className: classes.heightTextField,
                }}
                InputLabelProps={{
                  className: classes.label,
                }}
                className={classes.root}
                error={Boolean(touched.email && errors.email)}
                fullWidth
                helperText={touched.email && errors.email}
                label="Email"
                margin="normal"
                name="email"
                onBlur={handleBlur}
                onChange={handleChange}
                type={"text"}
                value={values.email}
                variant="filled"
                autoComplete="on"
              />

              <Box sx={{ mt: 2 }}>
                <Button
                  disableRipple
                  className={classes.button}
                  color="secondary"
                  fullWidth
                  size="large"
                  style={{ color: !submitted ? "#000" : "#BDC2C5" }}
                  disabled={submitted || isSubmitting}
                  type="submit"
                  variant="contained">
                  {submitted ? "Sent, Please check your email" : "Send Magic Link"}
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Grid>
    </div>
  );
}
